import { Server } from '@wajeez/wajeez.microservices';
import {
  osVersion,
  osName,
  browserVersion,
  browserName,
} from 'react-device-detect';

interface DeviceDetails {
  deviceMaker: string;
  modelName: string;
  operatingSystem: Server.OperatingSystems;
  operatingSystemVersion: string;
  applicationVersion: string;
}

export const getDeviceInfo = (): DeviceDetails => {
  return {
    deviceMaker: `${osName} - V:${osVersion}`,
    modelName: `${browserName} - V:${browserVersion}`,
    operatingSystem: Server.OperatingSystems.Web,
    operatingSystemVersion: osVersion,
    applicationVersion: browserVersion,
  };
};
